import { StyledBodyText, TextColor } from '../../../../common/Styleguide/Common/Text';
import { SxProps } from '@mui/system';
import { PropsWithChildren } from 'react';

interface TextAlertProps {
  children: React.ReactNode;
  sx?: SxProps;
  color?: TextColor;
}

const TextAlert: React.FC<TextAlertProps> = ({ children, sx, color }: PropsWithChildren<TextAlertProps>) => {
  return (
    <StyledBodyText variant="bodyLower" sx={{ marginBlock: 0, ...sx }} color={color || 'warning'}>
      {children}
    </StyledBodyText>
  );
};

export default TextAlert;
